module.exports = __webpack_public_path__ + "contratos-implantados.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/contratos-implantados.png
 ** module id = 750
 ** module chunks = 0
 **/